// store/slices/modalSlice.js
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isOpen: false,
  deleteItem: null,
};

const modalSlice = createSlice({
  name: "modal",
  initialState,
  reducers: {
    openModal: (state) => {
      state.isOpen = true;
    },
    closeModal: (state) => {
      state.isOpen = false;
    },
    toggleModal: (state) => {
      state.isOpen = !state.isOpen;
    },
    deleteItem: (state, action) => {
      // Implement delete logic here if needed
      state.deleteItem = action.payload;
    },
  },
});

export const { openModal, closeModal, toggleModal, deleteItem } =
  modalSlice.actions;
export default modalSlice.reducer;
